import React from 'react'
import { Select, Input, Tooltip, Button} from 'antd';
import './styles.css';
import { ArrowLeftOutlined, LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import TestCard from './localComponent/testCards';
import { useHistory } from 'react-router-dom';
import {  fetchTests, fetchTestsByStage, postPublishAllReady, toggleReloaderFlag, updateFilter, updateSelectedTest } from 'actions/testAdmin';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import PageDataLoader from 'components/pageDataLoader';
import moment from 'moment';
import ConfirmationModal from './modals/confirmationModal';
import { NodataCard } from './index';
import DropdownCheckbox from './localComponent/dropdownCheckbox';
import SearchBox from './localComponent/searchBox';
import Loader from './localComponent/loader';
import CustomDatePicker from './localComponent/customDatePicker';
import CreateTestModal from './modals/createTestModal';
import TestPublishModal from './localComponent/testPublishModal';
const {Option} = Select;
let timer = false;


    

const PageHeader = ({classFilters, handleDateFilterSelect, selectedDateFilter, getResultsBool, setSearchText, 
    handleClassFilterSelect, title, goBack, syllabusFilters, handleSyllabusFilterSelect, onDropdownClose, filter, searchVal, onDateChange, 
    defaultDate, syllabusDefaultVals}) => {
    const onSearchChange = (e) => {
        setSearchText(e.target.value);
    }
    return (
        <div className="resultPageHeader full-width">
                        <div className="r-c-fs m-r-30">
                            <ArrowLeftOutlined onClick={goBack} style={{fontSize:18}}/>
                            <div className="text-md bold-700 m-l-20"> {title} </div>
                        </div>
                        <div className="testfiltersgroup">
                            <DropdownCheckbox DATA={syllabusFilters} 
                                              placeholder={`Filter by syllabus`}
                                              onSelection={handleSyllabusFilterSelect}
                                              onDropdownClose={onDropdownClose}
                                              defaultValue={syllabusDefaultVals}/>

                            <CustomDatePicker style={{borderRadius:5, width:180}} className="m-r-10 m-l-10"
                                              onDateChange={onDateChange}
                                              defaultDate={defaultDate}
                                              placeholder={filter?.VAtype==='results'?'Filter by result date':'Filter by test date'}
                                            />

                            <DropdownCheckbox DATA={classFilters} 
                                              placeholder={`Filter by batch`}
                                              onSelection={handleClassFilterSelect}
                                              onDropdownClose={onDropdownClose}
                                              defaultValue={filter?.VAclasses}/>
                            
                            <SearchBox  loading={false} 
                                        onChange={onSearchChange}
                                        placeholder="Search by test name"
                                        style={{width:180, marginLeft:10}}
                                        value={searchVal}/>
                        </div>
                    </div>
    )
}



function ResultList({
    resultsToPublish,
    publishedResults,
    standards,
    fetchTests,
    getResultsBool,
    updateSelectedTest,
    isCModalVisible, 
    cModalType,
    reloadToggler,
    fetchTestsByStage,
    filter,
    updateFilter,
    toggleReloaderFlag,
    loaders,
    sentForFeedback, 
    feedbackFromTeacher, 
    testsToPublish,
    createTestModalBool,
    postPublishAllReady
}) {
    const [pageLoader, togglePageLoader] = useState(false);
    const [isdateFiltered, setIsDateFiltered] = useState(false);
    const [selectedDateFilter, setSelectedDateFilter] = useState('Week')
    const [selectedClassFilter, setSelectedClassFilter] = useState(null); 
    const [filtersChanged, setFiltersChanged] = useState(false);
    const [publishAllLoader, setPublishAllLoader] = useState(false)
    let count = 0;
    var startDate = ""
    var endDate = ""
    // useEffect(() => {
    //     setIsDateFiltered(false);
    //     // togglePageLoader(true);
    //     if (filter?.VAtype==='results'){
    //         fetchTestsByStage('results-to-publish', ()=>{});
    //         fetchTestsByStage('results-published', ()=>{});
    //     }else{
    //         fetchTestsByStage(filter?.VAtype, ()=>{});
    //     }
    // }, [reloadToggler]);

    useEffect(() => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (filter?.VAtype==='results'){
                    fetchTestsByStage('results-to-publish', ()=>{});
                    fetchTestsByStage('results-published', ()=>{});
                }else{
                    fetchTestsByStage(filter?.VAtype, ()=>{});
                }
            },800);
        }
      , [filter?.VAsearch]);
      useEffect(() => {
            if (filter?.VAtype==='results'){
                fetchTestsByStage('results-to-publish', ()=>{});
                fetchTestsByStage('results-published', ()=>{});
            }else{
                fetchTestsByStage(filter?.VAtype, ()=>{});
            }
    }
  , [filter?.vaDate]);
    const history = useHistory();
    const resultsDueToPublish = [];
    const setSearchText = (val) => {
        updateFilter('VAsearch', val)
    }
    const handleResultCardClick = (test) => {
        updateSelectedTest(test)
        history.push('test-publish-result-screen')
      }
    const handleClassFilterSelect = (selection)=>{
        setFiltersChanged(true);
        updateFilter('VAclasses', selection);
        if (filter?.VAtype==='results'){
            fetchTestsByStage('results-to-publish', ()=>{});
            fetchTestsByStage('results-published', ()=>{});
        }else{
            fetchTestsByStage(filter?.VAtype, ()=>{});
        }
    }
    const goBack = () => {
        history.goBack();
    }
    const onDropdownClose = () => {
        if (filtersChanged){
            toggleReloaderFlag();
            setFiltersChanged(false);
        }
    }
    const handleDateFilterSelect = (dateFilter, customDate)=>{
        endDate = moment().format("YYYY-MM-DD").toString();
        if (dateFilter&&dateFilter?.value == "Week"){
            startDate = moment().subtract(7,'d').format('YYYY-MM-DD').toString();
        }
        else if (dateFilter&&dateFilter?.value=="Month"){
            startDate = moment().startOf('month').format("YYYY-MM-DD").toString();
        }
        else if (dateFilter&&dateFilter?.value=="All"){
            endDate="";
            startDate="";
        }
        if (customDate?.length==2){
            startDate = customDate[0]?.split(' ')[0];
            endDate = customDate[1]?.split(' ')[0];
        }
        togglePageLoader(true);
        fetchTests("test-result-publish", (bool)=>{}, startDate, endDate);
        fetchTests("test-result-published", (bool)=>togglePageLoader(bool), startDate, endDate);
    }
    const classFilters = [...standards?.map(item => ({val:`${item.standard_std} - ${item.standard_section}`, id:item.standard_id}))]
    const syllabusFilters = [{val:'Chapter Test', id:1}, {val:'Part Test', id:2}, {val:'Full Test', id:3}]
    const syllabusDefaultVals = [];
    syllabusFilters.forEach((item)=>{
        if (filter?.VAsyllabus.includes(item.val)){
            syllabusDefaultVals.push(item.id);
        }
    })
    let currentdate = moment().format('YYYY/MM/DD').toString()
    const handleSyllabusFilterSelect = (selection)=>{
        let tempsyllabus = [];
        for (let id of selection){
            tempsyllabus.push(syllabusFilters[id-1].val);
        }
        setFiltersChanged(true);
        updateFilter('VAsyllabus', tempsyllabus);
        if (filter?.VAtype==='results'){
            fetchTestsByStage('results-to-publish', ()=>{});
            fetchTestsByStage('results-published', ()=>{});
        }else{
            fetchTestsByStage(filter?.VAtype, ()=>{});
        }
    }

    const onDateChange = (v) => {
        if (v==undefined){
        updateFilter('isVAdatefiltered', false);
        updateFilter('vaDate', null);
        }else{
            updateFilter('isVAdatefiltered', true);
            updateFilter('vaDate', v.format("YYYY-MM-DD"));
        }
    }
    return (
        <div className="testListPage" style={{backgroundColor:"#FAFAFA", margin:-20, padding:20, overflow:"hidden", height:"calc(100% +40vh)"}}>
            <PageHeader classFilters={classFilters}
                        syllabusFilters={syllabusFilters} 
                        title={filter?.VAtype==="results"?"Result(s)":filter?.VAtype==='feedback'?'Feedback(s)':filter?.VAtype==='review'?'Test(s) to be Reviewed':filter?.VAtype==='ready'?'Test(s) Ready to be Published':''}
                        goBack={goBack}
                        handleDateFilterSelect={handleDateFilterSelect} 
                        setSearchText={setSearchText} 
                        selectedDateFilter={selectedDateFilter} 
                        getResultsBool={getResultsBool}
                        handleClassFilterSelect={handleClassFilterSelect}
                        handleSyllabusFilterSelect={handleSyllabusFilterSelect}
                        onDropdownClose={onDropdownClose}
                        filter={filter}
                        searchVal={filter?.VAsearch}
                        onDateChange={onDateChange}
                        defaultDate={filter?.vaDate}
                        syllabusDefaultVals={syllabusDefaultVals}
                        />
            {/* {filter?.VAtype === "ready" ?
                <div className='r-c-fe' style={{ padding: "30px 0px 20px 0px" }}>
                    <Button
                        loading={publishAllLoader}
                        className="backBlue white radius-100 absolute"
                        onClick={() => {
                            setPublishAllLoader(true);
                            postPublishAllReady(() => {
                                setPublishAllLoader(false)
                            })
                        }}
                    >PUBLISH ALL TEST</Button>
                </div>
                :
                <></>
            } */}
                    {
                        loaders?.vaPageLoader?
                        <div style={{height:"88vh"}}>
                        <Loader style={{fontSize:40}}/>
                        </div>
                        :
                        <div style={{overflowY:"auto", height:"100%", paddingBottom:20}} className="m-t-20">
                            {
                                filter?.VAtype==='results'?
                                <>
                                {resultsToPublish?.length>0
                                    ?
                                        <div className="m-t-30">
                                            <h4>Result(s) due to be published </h4>
                                            <div className="r-c-fs flex-wrap">
                                                {resultsToPublish?.map((test, index)=>
                                                    <>
                                                    <span style={{display:"none"}}>{count+=1}</span>
                                                    <TestCard type='published' key={index} test={test} index={index} ispublished={false} handleResultCardClick={handleResultCardClick}/>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    :
                                    null
                                }   
                                {publishedResults?.length>0
                                    ?
                                    <div className="m-t-30">
                                        <h4> Result(s) published </h4>
                                        <div className="r-c-fs flex-wrap">
                                            {publishedResults?.map((test, index)=>
                                                <>
                                                <span style={{display:"none"}}>{count+=1}</span>
                                                <TestCard type='published' key={index} 
                                                        test={test} index={index} 
                                                        ispublished={true} handleResultCardClick={handleResultCardClick}/></>)}
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                {resultsToPublish?.length===0&&publishedResults?.length===0?
                                <div style={{height:"83vh"}}> <NodataCard imgheight="35%" imgwidth="35%"/></div>:null}
                                </>
                                :filter?.VAtype==='feedback'?
                                <>
                                {console.log("iamhere")}
                                <div className="r-c-fs flex-wrap">
                                {feedbackFromTeacher?.map((test, index) => (
                                    <TestCard
                                        type="Feedback"
                                        test={test}
                                        key={index}
                                        index={index}
                                        handleResultCardClick={handleResultCardClick}
                                        sendForFeedback={false}
                                        fromHome={true}
                                        dash={true}
                                    />
                                    ))
                                }
                                </div>
                                {feedbackFromTeacher?.length===0?
                                <div style={{height:"83vh"}}> <NodataCard imgheight="35%" imgwidth="35%"/></div>:null}
                                </>
                                :filter?.VAtype==='ready'?
                                <>
                                <div className="r-c-fs flex-wrap">
                                {testsToPublish?.map((test, index)=>(
                                    <TestCard type='dash_scheduled' 
                                              test={test}
                                              key={index} 
                                              index={index} 
                                              handleResultCardClick={handleResultCardClick}/>
                                    ))
                                }
                                </div>
                                {testsToPublish?.length===0?
                                <div style={{height:"83vh"}}> <NodataCard imgheight="35%" imgwidth="35%"/></div>:null}
                                </>
                                :filter?.VAtype==='review'?
                                <>
                                <div className="r-c-fs flex-wrap">
                                {sentForFeedback?.map((test, index) => (
                                    <TestCard
                                        type="Feedback"
                                        test={test}
                                        key={index}
                                        index={index}
                                        handleResultCardClick={handleResultCardClick}
                                        sendForFeedback={true}
                                        dash={true}
                                    />
                                    ))}
                                </div>
                                {sentForFeedback?.length===0?<div style={{height:"83vh"}}> <NodataCard imgheight="35%" imgwidth="35%"/></div>:null}
                                </>
                                :null
                            }
                        </div>
                    }
        <ConfirmationModal isCModalVisible={isCModalVisible}  cModalType={cModalType}/>
        <TestPublishModal history={history} />
        <PageDataLoader visible={pageLoader}/>
        {createTestModalBool && <CreateTestModal history={history} />}
        </div>
    )
}
const mapStateToProps = state =>{
    const {resultsToPublish, publishedResults, standards, getResultsBool, isCModalVisible, 
        cModalType, reloadToggler, filter, loaders, sentForFeedback, feedbackFromTeacher, testsToPublish, createTestModalBool}=state.testAdmin;
    return { resultsToPublish, publishedResults, standards, getResultsBool, isCModalVisible, 
        cModalType, reloadToggler, filter, loaders, sentForFeedback, feedbackFromTeacher, testsToPublish, createTestModalBool}
}

const mapDispatchToProps = dispatch=> ({
    fetchTests: (type, callback, startDate, endDate, searchText)=>dispatch(fetchTests(type, callback, startDate, endDate, searchText)),
    updateSelectedTest: (test)=> dispatch(updateSelectedTest(test)),
    fetchTestsByStage: (type, callback) => dispatch(fetchTestsByStage(type, callback)),
    updateFilter: (key, val) => dispatch(updateFilter(key, val)),
    toggleReloaderFlag: () => dispatch(toggleReloaderFlag()),
    postPublishAllReady : (callBack) => dispatch(postPublishAllReady(callBack))
})
export default connect(mapStateToProps, mapDispatchToProps)(ResultList);
